<template>
  <div class="order-reworks">
    <h3>售后记录</h3>
    <table class="table table-sm" v-if="reworks && reworks.length > 0">
      <thead>
        <tr>
          <th>时间</th>
          <th>责任方</th>
          <th>备注</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="rework of reworks">
          <td><local-time :time="rework.created_at * 1000"></local-time></td>
          <td v-if="rework.to_blame === 'printer'">打印厂</td>
          <td v-if="rework.to_blame === 'company'">公司</td>
          <td class="text-danger">{{rework.message}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import LocalTime from '@/components/_small/LocalTime'

export default {
  name: 'order-reworks',
  props: ['reworks'],
  data () {
    return {
    }
  },
  components: {
    LocalTime
  }
}
</script>
